import React, { useState, useEffect } from "react";
import "../Style.css";
import "../Responsive.css";
import "../bootstrap.min.css";
import { loadProductsFromServer } from "../core/serviceClient";
import { Box, Container } from "@mui/system";
import Utils from "../core/Utils";
import UserHelper from "../core/UserHelper";
import {
    LedgerPage,
    LoginPage,
    PurchaseOrderPage,
} from "../core/PageConstants";
import { useNavigate } from "react-router-dom";
import {
    Button,
    Card,
    CardContent,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormHelperText,
    Grid,
    IconButton,
    TextField,
    Typography,
    Chip,
    Stack
} from "@mui/material";
import Loader from "./common/Loader";
import MessagePopup from "./common/MessagePopUp";
import SideBarMenuItems from "./SideBarMenuItems";
import { SideBarMenuNames } from "../core/Constants";
import { OverviewPage } from "../core/PageConstants";
import "../DateRangePickerWithYear.css";
import "react-calendar/dist/Calendar.css";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { useDispatch } from "react-redux";
import { connectToStore } from "../data/store";
import { postAsync } from "../core/serviceClient";
import VendorSelectionDialog from "./dialogs/VendorSelectionDialog";
import styled from "@emotion/styled";
import CloseIcon from "@mui/icons-material/Close";
import DecimalEntryField from "./common/controls/DecimalEntryField";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

const Ledger = () => {
    document.title = "Ledger";
    var pageTitle = "Ledger";
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [products, setProducts] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [msgOpen, setMsgOpen] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isNavigateToLogin, setIsNavigateToLogin] = useState(false);
    const [isSelectedProduct, setIsSelectedProduct] = useState(false);
    const [vendorList, setVendorList] = useState([]);
    const [localSettings, setLocalSettings] = useState({});
    const [paymentAmount, setPaymentAmount] = useState("");
    const [description, setDescription] = useState("");
    const [isSaving, setIsSaving] = useState(false);



    useEffect(() => {
        let localSetting = connectToStore();
        if (UserHelper.CheckPermission(LedgerPage, navigate)) {
            setLocalSettings(localSetting);
            getBelowThresholdProducts();
        }
    }, []);


    const [selectedVendor, setSelectedVendor] = useState(null);

    const openLedger = (vendor) => {
        setSelectedVendor(vendor);
    };

    const getBelowThresholdProducts = async () => {
        setIsLoading(true);
        var result = await loadProductsFromServer();
        setIsNavigateToLogin(result.isNavigateToLogin);
        if (result.error) {
            setMsgOpen(true);
            setMsgText(result.errorMessage);
        }
        var data = result.data;
        if (!Utils.IsNullOrEmptyArray(data)) {
            data = data.filter(
                (c) =>
                    c.service === false &&
                    c.isMaterial === false &&
                    c.threshold > c.onHandQuantity
            );
        }
        setProducts(data);
        setIsLoading(false);
    };
    const handleMsgClose = () => {
        setMsgOpen(false);
        if (isNavigateToLogin) {
            UserHelper.LogOut(dispatch);
            navigate(LoginPage.Path);
        }
    };
    const backNavigation = () => {
        navigate(OverviewPage.Path, {});
    };

    const handleCheckboxChange = (index, checked) => {
        let updatedProducts = [...products];
        updatedProducts[index].isChecked = checked;

        setProducts(updatedProducts);
        let selectedItems = updatedProducts.filter((p) => p.isChecked);
        setSelectedProducts(selectedItems);
    };

    const handleCartClick = () => {
        setIsSelectedProduct(!isSelectedProduct);
    };
    const [openDialog, setOpenDialog] = React.useState(false);

    const handleOpenDialog = () => setOpenDialog(true);
    const handleCloseDialog = () => setOpenDialog(false);

    useEffect(() => {
        getallVendorbalanceDetails();
    }, [localSettings]);

    const getallVendorbalanceDetails = async () => {
        if (!localSettings.authenticated) return;

        setIsLoading(true);

        let result = await postAsync(
            "ProductIntakes/GetAllVendorLedgerBalance", {
            BusinessId: localSettings.business.id,
            BranchId: localSettings.branch.branchId,
        }
        );

        setIsNavigateToLogin(result.isNavigateToLogin);

        if (result.error) {
            setMsgOpen(true);
            setMsgText(result.errorMessage);
        } else {
            if (!Utils.IsNullOrEmptyArray(result?.data)) {
                setVendorList(result.data);
            }
        }

        setIsLoading(false);
    };

    const NavigationPurchaseOrder = () => {
        navigate(PurchaseOrderPage.Path, {
            state: {
                SelectedProduct: selectedProducts,
                SelectedVendor: selectedVendor,
            },
        });
        setSelectedProducts([]);
    };

    const saveLedgerPayment = async () => {
        if (isSaving) return;
        setIsSaving(true);

        try {
            if (!paymentAmount || paymentAmount <= 0) {
                setMsgOpen(true);
                setMsgText("Please enter a valid payment amount");
                return;
            }

            const payload = {
                BusinessId: localSettings.business.id,
                BranchId: localSettings.branch.branchId,
                ledgerId: selectedVendor.id,
                Amount: Number(paymentAmount),
                Description: description
            };

            let result = await postAsync(
                "ProductIntakes/SaveVendorLedgerPayment",
                payload
            );

            if (!result.error) {
                setSelectedVendor(null);
                setPaymentAmount("");
                setDescription("");
                setVendorList([]);
                getallVendorbalanceDetails();
            } else {
                setMsgOpen(true);
                setMsgText(result.errorMessage);
            }
        } finally {
            setIsSaving(false);
        }
    };


    return (
        <Container maxWidth="false" className="bg-color p-0">
            <Grid className="container">
                <Loader open={isLoading} />
                <MessagePopup
                    msgOpen={msgOpen}
                    msgText={msgText}
                    onMsgClose={handleMsgClose}
                />
                <VendorSelectionDialog
                    open={openDialog}
                    onClose={handleCloseDialog}
                    vendorList={vendorList}
                    selectedVendor={selectedVendor}
                    setSelectedVendor={setSelectedVendor}
                    onSubmit={NavigationPurchaseOrder}
                />
                {selectedVendor && (

                    <BootstrapDialog
                        aria-labelledby="customized-dialog-title"
                        open={true} onClose={() => setSelectedVendor(null)}
                    >
                        <BootstrapDialogTitle
                            id="customized-dialog-title"
                            onClose={() => setSelectedVendor(null)}
                        >
                            <Typography
                                level="h3"
                                component="h3"
                                fontWeight="600"
                                fontSize="2rem"
                                className="h3"
                            >
                                Vendor Ledger
                            </Typography>
                        </BootstrapDialogTitle>


                        <DialogContent className="cs-form">
                            <Box sx={{ mb: 2 }}>
                                <Typography fontSize={14} color="text.secondary">
                                    Vendor
                                </Typography>
                                <Typography fontWeight={600} fontSize={16}>
                                    {selectedVendor.vendorName}
                                </Typography>
                            </Box>

                            <Box
                                className="card"
                                padding={2}
                                marginBottom={2}
                            >
                                <Typography fontSize={14} color="text.secondary">
                                    Balance
                                </Typography>
                                <Typography fontSize={20} fontWeight={700} color="error.main">
                                    {Utils.GetCurrency(selectedVendor.balanceAmount, localSettings.country)}
                                </Typography>
                            </Box>

                            <FormControl fullWidth>
                                <DecimalEntryField
                                    id="paymentAmount"
                                    label="Payment Amount"
                                    variant="outlined"
                                    inputProps={{ style: { fontSize: 16 } }}
                                    sx={{ mt: 1 }}
                                    value={paymentAmount}
                                    setError={!paymentAmount}
                                    setValue={setPaymentAmount}
                                    InputLabelProps={{ shrink: true }}
                                    maxLengthValue={selectedVendor?.balanceAmount?.toString().length}
                                />
                                <FormHelperText sx={{ fontSize: "11px", textAlign: "right", margin: "4px 0 0 0" }}>
                                    {!paymentAmount && "Payment amount is required"}
                                    {paymentAmount <= 0 && " Amount must be greater than zero"}
                                    {paymentAmount > selectedVendor?.balanceAmount && " Amount exceeds balance"}
                                </FormHelperText>
                            </FormControl>

                            <Stack marginTop={1}>
                                <TextField
                                    label="Description"
                                    fullWidth
                                    inputProps={{ style: { fontSize: 13 } }}
                                    multiline
                                    rows={3}
                                    sx={{ mt: 2 }}
                                    value={description}
                                    error={!description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    placeholder="Cash / UPI / Bank transfer"
                                />
                            </Stack>
                        </DialogContent>

                        <DialogActions>
                            <Button
                                autoFocus
                                className="btn btn-secondary"
                                color="primary"
                                variant="contained"
                                style={{ backgroundColor: "gray" }}
                                onClick={() => setSelectedVendor(null)}>
                                Cancel
                            </Button>
                            <Button
                                autoFocus className="btn btn-primary white-text" variant="contained"
                                onClick={saveLedgerPayment}
                                disabled={isSaving || !description || !paymentAmount > 0}
                            >
                                {isSaving ? "Saving..." : "Save"}
                            </Button>
                        </DialogActions>
                    </BootstrapDialog>
                )}

                <Box>
                    <Grid container m={0}>
                        <SideBarMenuItems selectedTab={SideBarMenuNames.Overview} />
                        <Grid
                            xs={12}
                            className="content-sec"
                            sx={{ "padding-bottom": "100px" }}
                        >
                            <Grid container direction="row" className="">
                                <Grid flex="1" spacing={2} className="form-sec p-0">
                                    <Grid
                                        container
                                        className="title-sec"
                                        alignItems="center"
                                        justifyContent="space-between"
                                    >
                                        <Typography
                                            level="h2"
                                            component="h2"
                                            fontWeight="600"
                                            fontSize="2rem"
                                            className="page-title text-center"
                                        >
                                            <Button onClick={backNavigation} className="back-btn">
                                                <NavigateBeforeIcon fontSize="large" />
                                            </Button>
                                            Vendor Ledger
                                        </Typography>

                                        <Grid container spacing={2}>
                                            {vendorList.map((vendor) => (
                                                <Grid item xs={12} sm={6} md={4} key={vendor.VendorId}>
                                                    <Stack
                                                        padding={2}
                                                        className="card white-bg"
                                                        sx={{ cursor: "pointer" }}
                                                        alignItems="Start"
                                                        onClick={() => openLedger(vendor)}
                                                    >
                                                        <Typography
                                                            variant="h4"
                                                            fontSize="1.8rem"
                                                            fontWeight="600"
                                                            marginBottom="1rem">
                                                            {vendor.vendorName}
                                                        </Typography>
                                                        <Chip fontSize="1.6rem"
                                                            fontWeight="600"
                                                            label={vendor.vendorContactNo} />

                                                        <Typography
                                                            fontSize="1.4rem"
                                                            marginTop="3rem">
                                                            Balance: <Typography variant="span" sx={{ color: "#f00" }}>{Utils.GetCurrency(vendor.balanceAmount, localSettings.country)}</Typography>
                                                        </Typography>
                                                    </Stack>
                                                </Grid>
                                            ))}
                                        </Grid>

                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
        </Container>
    );
};
export default Ledger;
